<template>
  <div id="otherLayout" :class="['other-layout-wrapper']">
    <router-view />
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted } from 'vue';

export default defineComponent({
  name: 'OtherLayout',
  setup() {
    onMounted(() => {
      document.body.classList.add('otherLayout');
    });
    onUnmounted(() => {
      document.body.classList.remove('otherLayout');
    });

    return {};
  },
});
</script>

<style lang="less" scoped>
#otherLayout.other-layout-wrapper {
  height: 100%;
  &.mobile {
    .container {
      .main {
        width: 98%;
        max-width: 368px;
      }
    }
  }
}
</style>
